import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "form-group row" };
const _hoisted_3 = {
    class: "col-sm-3 col-form-label",
    for: "inputExpiry"
};
const _hoisted_4 = { class: "col-sm-9 pt-1" };
const _hoisted_5 = { class: "form-group row" };
const _hoisted_6 = {
    class: "col-sm-3 col-form-label",
    for: "inputTenant"
};
const _hoisted_7 = { class: "col-sm-9" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { class: "form-group row" };
const _hoisted_10 = {
    class: "col-sm-3 col-form-label",
    for: "inputCount"
};
const _hoisted_11 = { class: "col-sm-9" };
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = { class: "form-group row" };
const _hoisted_14 = {
    class: "col-sm-3 col-form-label",
    for: "inputCode"
};
const _hoisted_15 = { class: "col-sm-9" };
const _hoisted_16 = ["placeholder"];
const _hoisted_17 = { class: "form-group row" };
const _hoisted_18 = {
    class: "col-sm-3 col-form-label",
    for: "editActive"
};
const _hoisted_19 = { class: "col-sm-9 row ml-0" };
const _hoisted_20 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "addCode",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_CODES_ADD_CODE')
        }, {
            default: _withCtx(() => [
                ($setup.code)
                    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_CODES_EXPIRY')), 1),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode($setup["BInput"], {
                                    class: "datepicker",
                                    id: "inputExpiry",
                                    modelValue: $setup.code.expires_at,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.code.expires_at) = $event)),
                                    type: "date",
                                    placeholder: _ctx.$t('JTADM_CODES_SELECT_A_DATE')
                                }, null, 8, ["modelValue", "placeholder"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('JTADM_CODES_TENANT')), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    id: "inputTenant",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.currentUserStore.tenantName) = $event)),
                                    type: "text",
                                    placeholder: _ctx.$t('JTADM_CODES_TENANT'),
                                    disabled: ""
                                }, null, 8, _hoisted_8), [
                                    [_vModelText, $setup.currentUserStore.tenantName]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('JTADM_CODES_USABLE_FOR')), 1),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    id: "inputCount",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.code.use_count) = $event)),
                                    type: "number",
                                    placeholder: _ctx.$t('JTADM_CODES_NUMBER_OF_TIMES')
                                }, null, 8, _hoisted_12), [
                                    [
                                        _vModelText,
                                        $setup.code.use_count,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('JTADM_CODE')), 1),
                            _createElementVNode("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    id: "inputCode",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.code.text) = $event)),
                                    type: "text",
                                    placeholder: _ctx.$t('JTADM_CODE'),
                                    autocomplete: "off"
                                }, null, 8, _hoisted_16), [
                                    [_vModelText, $setup.code.text]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('JTADM_CODES_ACTIVE')), 1),
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode($setup["CommonSwitchInput"], {
                                    value: $setup.code.active,
                                    onChange: _cache[4] || (_cache[4] = ($event) => ($setup.code.active = !$setup.code.active))
                                }, null, 8, ["value"])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_20, [
                    _createElementVNode("button", {
                        class: "btn btn-success",
                        type: "submit",
                        onClick: _withModifiers($setup.addSubmit, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_CODES_CREATE')), 1),
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => ($setup.addCode?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
